export var UIM_CONSENT_UNKNOWN = 'unknown';
export var UIM_CONSENT_REQUIRED = 'required';
export var UIM_CONSENT_CONSENTED = 'consented';